import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="document-check"
export default class extends Controller {
  static targets = ["checkbox", "row", "agreeBox", "agreeLabel", "submitButton", "unitCount", "totalAmount"]

  open(event) {
    const row = event.currentTarget
    const index = this.rowTargets.indexOf(row)
    const checkbox = this.checkboxTargets[index]

    if (checkbox && !checkbox.dataset.checked) {
      checkbox.dataset.checked = "true"
      checkbox.classList.remove("border-2", "border-line", "bg-white")
      checkbox.classList.add("bg-navy")
      checkbox.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>`
      this.#updateAgreeState()
    }
  }

  toggleAgree() {
    if (!this.#allDocumentsChecked()) return

    const box = this.agreeBoxTarget
    const checked = box.dataset.checked === "true"

    if (checked) {
      box.dataset.checked = ""
      box.classList.remove("bg-navy")
      box.classList.add("border-2", "border-line", "bg-white")
      box.innerHTML = ""
    } else {
      box.dataset.checked = "true"
      box.classList.remove("border-2", "border-line", "bg-white")
      box.classList.add("bg-navy")
      box.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>`
    }
    this.#updateSubmitState()
  }

  selectAll(event) {
    event.target.select()
  }

  calculateAmount() {
    const input = this.unitCountTarget
    const units = parseInt(input.value, 10) || 0
    const unitAmount = parseInt(input.dataset.unitAmount, 10)
    const total = units * unitAmount
    this.totalAmountTarget.textContent = total.toLocaleString()
  }

  #allDocumentsChecked() {
    return this.checkboxTargets.every(cb => cb.dataset.checked === "true")
  }

  #updateAgreeState() {
    const enabled = this.#allDocumentsChecked()
    if (enabled) {
      this.agreeLabelTarget.classList.remove("text-ink-faint")
      this.agreeLabelTarget.classList.add("text-ink")
      this.agreeBoxTarget.classList.add("cursor-pointer")
    }
  }

  #updateSubmitState() {
    const agreed = this.agreeBoxTarget.dataset.checked === "true"
    const btn = this.submitButtonTarget

    if (agreed) {
      btn.disabled = false
      btn.classList.remove("bg-line", "text-white", "cursor-not-allowed")
      btn.classList.add("bg-brand", "text-ink", "hover:bg-brand-hover", "cursor-pointer")
    } else {
      btn.disabled = true
      btn.classList.remove("bg-brand", "text-ink", "hover:bg-brand-hover", "cursor-pointer")
      btn.classList.add("bg-line", "text-white", "cursor-not-allowed")
    }
  }
}
